var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-select',{attrs:{"title":"el tema del editor"},model:{value:(_vm.cmOption),callback:function ($$v) {_vm.cmOption=$$v},expression:"cmOption"}},_vm._l((_vm.themes),function(theme,index){return _c('b-form-select-option',{key:index,attrs:{"value":theme.val}},[_vm._v(_vm._s(theme.name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }